"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTimePickerControlValueFormatter = void 0;
const constants_1 = require("./constants");
const formatValue_1 = require("./formatValue");
const defaultTimePickerControlValueFormatter = ({ value, is12Hours, texts }) => {
    const uiTexts = Object.assign({ am: constants_1.TIME_PICKER_DEFAULT_TEXTS.am, pm: constants_1.TIME_PICKER_DEFAULT_TEXTS.pm }, texts);
    return value ? (0, formatValue_1.formatValue)(value, is12Hours, uiTexts) : '';
};
exports.defaultTimePickerControlValueFormatter = defaultTimePickerControlValueFormatter;
//# sourceMappingURL=defaultTimePickerControlValueFormatter.js.map